export default {
  methods: {
    desktopImageFallback(arr, mediaquery) {
      var ret = new Array();
      _.map(arr, function(obj) {
        ret[obj.format.toLowerCase()] = obj
      })
      return ret[mediaquery] || ret['desktop']
    },

    desktopSliderImageFallback(arr, mediaquery) {
      var ret = new Array();
      _.map(arr, function(obj) {
        ret[obj.resolutionCode.toLowerCase()] = obj
      })
      return ret[mediaquery] || ret['desktop']
    }
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/mixins/desktopImageMixin.js